const pathConstants = Object.freeze({
  onboarding: {
    PERSONAL_INFO_PATH: '',
    HOUSING_VEHICLE_PATH: 'housing',
    UNIFORM_SWAG_PATH: 'uniform',
    LICENSING_PATH: 'licensing',
    HR_PATH: 'hr',
    DOCUMENTS_PATH: 'documents',
    WORKDAY_TASKS_PATH: 'workday-tasks',
    ATTACHMENTS_PATH: 'attachments',
    ADMIN_VIEW_PATH: 'admin-view',
  },
});

export default pathConstants;
